import { Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BuyerPreviewService } from '../buyer-preview.service';
import { MultiSectionFormPreviewService } from '../multi-section-form-preview/multi-section-form-preview.service';

@Component({
    selector: 'app-submit-survey-confirmation',
    templateUrl: './submit-survey-confirmation.component.html',
    styleUrls: ['./submit-survey-confirmation.component.css'],
    standalone: true,
})
export class SubmitSurveyConfirmationComponent {
  private _modalService = inject(NgbModal);
  private _buyerPreviewService = inject(BuyerPreviewService);
  public msfps = inject(MultiSectionFormPreviewService);

  @ViewChild('submitSurveyConfirmation', { static: true })
  submitSurveyConfirmationModalTemplate: TemplateRef<any>;

  openLg(content: TemplateRef<any>) {
    this._modalService.open(content, { scrollable: true }).result.then(
      (modalClosedAction: string) => {
        if (modalClosedAction) {
          this._buyerPreviewService.helper$.next(modalClosedAction);
        }
      },
      () => {}
    );
  }

  openConfirmationDialog(content: TemplateRef<any>) {
    this._modalService.open(content, { scrollable: true }).result.then(
      (modalClosedAction: string) => {
        if (modalClosedAction) {
          this.msfps.modalHelper$.next(modalClosedAction);
        }
      },
      () => {}
    );
  }

  ngAfterViewInit() {
    this._buyerPreviewService.helper$.asObservable().subscribe({
      next: (helperVal: string) => {
        if (helperVal === 'SUBMIT_CONFIRMATION_MODAL_OPEN') {
          this.openLg(this.submitSurveyConfirmationModalTemplate);
        }
      },
    });
    this.msfps.modalHelper$.asObservable().subscribe({
      next: (helperVal: string) => {
        if (helperVal === 'SUBMIT_CONFIRMATION_MODAL_OPEN') {
          this.openConfirmationDialog(
            this.submitSurveyConfirmationModalTemplate
          );
        }
      },
    });
  }
}
